<template>
    <div class="bg " :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
        <div class="content m_rl_20">
            <div class="content_title">
                <img src="../assets/img/error.png" alt="" class="error">
            </div>
            <div class="content_con">
                <!--  -->
                <!--  -->
                <p>{{ $t('ThisCardHasAlready') }}</p>
                <!-- <p  style="margin-bottom:1.25rem">Thank You For Your Effort To Neutralize Your Carbon Footprint !</p>
                <span >Our Earth Needs Your Help ! </span> -->
            </div>

        </div>
        <div class=" please">
            <!-- Please visit 
            <a href="https://www.mvgx.com/">https://www.mvgx.com/ </a>
            for more information about our products  -->
        </div>
        <div class="m_rl_20">
            <a href="https://www.mvgx.com/">
                <el-button class="btn">
                    {{ $t('VisitMVGX') }}</el-button>
            </a>
        </div>
    </div>
</template>
<script>
import cnt from '@/api/cnt'
export default {
    data() {
        return {
            sn: '',
            config: '',
        }
    },
    mounted() {
        // this.getUserEvent(1,1)
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
    },
}
</script>
<style scoped>
a {
    color: #ffffff;
    text-decoration: none;
}

.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.logo {
    width: auto;
    margin: 2.5rem .625rem 3.6875rem;
}

.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(.3125rem);
    padding: 3.0625rem 0;
    text-align: center;
    color: #fff;
    border-radius: 1.25rem;
}

.error {
    width: 3.375rem;
    height: 3.375rem;
    margin-bottom: 2.0625rem;

}

.content_con {
    margin: 0 1.25rem;
    font-size: .9375rem;
    font-family: Century Gothic;
}

.please {
    margin: 3.75rem 1.25rem 7.25rem;
    font-size: .8125rem;
    font-family: Century Gothic;
    color: #FFFFFF;
    text-align: center;

}

.please>span {
    font-weight: bold;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4D94A0;
    margin-bottom: 1.3125rem;
    border-radius: .625rem;
    font-size: .9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
}
</style>
